let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fbjG6")).then(() => parcelRequire('ePXk1'));